import React, { useState } from 'react';
import { useToasts } from 'react-toast-notifications';
import { useMutation } from 'urql';
import Button from '../../../../components/buttons/button';
import { BlurredContainerM3030 } from '../../../../components/containers/containers';
import StyledInput from '../../../../components/inputs/styled-input';
import { GraphqlOperations } from '../../../../logic/graphql/operations';
import { useUserPhoneNumber } from '../../../../logic/graphql/hooks';
import { FormattedMessage, useIntl } from 'react-intl';

const NewExchangeOrderConfirmation = (props: {
  onSuccess: () => void;
  onBackClick: () => void;
  token?: string;
  needsConfirmation?: boolean;
}): JSX.Element => {
  const { addToast } = useToasts();
  const { phoneNumber } = useUserPhoneNumber();
  const intl = useIntl();
  const [smsCode, setSMSCode] = useState<string>('');
  const [smsCodeError, setSMSCodeError] = useState<string>('');

  const confirmPassword = useMutation(
    GraphqlOperations.mutations.create_exchange_order_confirm.mutationString,
  )[1];

  const handleNext3Click = (): void => {
    if (props.token) {
      const variables = GraphqlOperations.mutations.create_exchange_order_confirm.createVars(
        smsCode,
        props.token,
      );
      confirmPassword(variables)
        .then((result) => {
          if (result && !result.error) {
            addToast(
              intl.formatMessage({ id: 'exchangeOrderFormPage.confirmation.toast.success' }),
              {
                appearance: 'success',
                autoDismiss: true,
              },
            );
            props.onSuccess();
          } else {
            if (props.needsConfirmation) {
              setSMSCodeError(
                intl.formatMessage({
                  id: 'exchangeOrderFormPage.confirmation.toast.invalidPassword',
                }),
              );
            }
          }
          return true;
        })
        .catch(() =>
          setSMSCodeError(
            intl.formatMessage({ id: 'exchangeOrderFormPage.confirmation.toast.invalidPassword' }),
          ),
        );
    }
  };

  const handleSMSChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setSMSCode(event.currentTarget.value);
  };

  const confirmationContent = (
    <>
      <h2 className="mb-6">
        <FormattedMessage id="exchangeOrderFormPage.confirmation.smsSignLabel" />
      </h2>
      <p
        className="text-14 mb-6"
        dangerouslySetInnerHTML={{
          __html: intl.formatMessage(
            { id: 'exchangeOrderFormPage.confirmation.smsSignText' },
            { phoneNumber },
          ),
        }}
      />
      <StyledInput
        type="text"
        autoComplete="one-time-code"
        inputMode="numeric"
        placeholder={intl.formatMessage({
          id: 'exchangeOrderFormPage.confirmation.smsCodePlaceholder',
        })}
        onChange={handleSMSChange}
        error={smsCodeError}
        onEnterPress={handleNext3Click}
      />
    </>
  );

  const infoContent = (
    <>
      <h2 className="mb-6">
        <FormattedMessage id="exchangeOrderFormPage.confirmation.confirmationLabel" />
      </h2>
      <p className="text-14 mb-6">
        <FormattedMessage id="exchangeOrderFormPage.confirmation.confirmationText" />
      </p>
    </>
  );

  const content = props.needsConfirmation ? confirmationContent : infoContent;

  return (
    <BlurredContainerM3030 className="mb-3">
      {content}
      <div className="flex flex-row mt-6">
        <Button secondary onClick={props.onBackClick} className="mr-3">
          <FormattedMessage id="exchangeOrderFormPage.confirmation.backButton" />
        </Button>
        <Button onClick={handleNext3Click}>
          <FormattedMessage id="exchangeOrderFormPage.confirmation.confirmButton" />
        </Button>
      </div>
    </BlurredContainerM3030>
  );
};

export default NewExchangeOrderConfirmation;
